import React from "react";

export function LinearMethod() {
  return (
    <div className="engagement-tiers-grid">
      {/* Tier 1 */}
      <div className="tier-card">
        <div className="tier-badge">Sprint</div>
        <h3 className="tier-title">Architecture &amp; Scoping Sprint</h3>
        <span className="tier-timeline">2 Weeks Execution</span>
        <p className="tier-description">
          Deep architectural audit of your technical workflows, prompt governance, CRM bottlenecks,
          and a validated proof-of-concept deployable to staging.
        </p>
        <ul className="tier-deliverables">
          <li>Comprehensive Systems Architecture Blueprint</li>
          <li>Evals benchmark &amp; LLM cost optimization model</li>
          <li>CRM &amp; Meta Cloud API integration specification</li>
          <li>Working Proof-of-Concept agent runtime</li>
        </ul>
        <a href="#book-call" className="tier-btn">Select Architecture Sprint →</a>
      </div>

      {/* Tier 2: Highlighted */}
      <div className="tier-card featured">
        <div className="tier-badge popular">Core Production</div>
        <h3 className="tier-title">Dedicated Systems Build</h3>
        <span className="tier-timeline">4–8 Weeks Delivery</span>
        <p className="tier-description">
          Full-lifecycle engineering of custom multi-agent networks, CRM automation pipelines,
          operational command dashboards, and security-gated production deploy.
        </p>
        <ul className="tier-deliverables">
          <li>Production-grade autonomous agent swarms</li>
          <li>Meta Cloud API + GoHighLevel deep synchronization</li>
          <li>Custom Mission Control telemetry &amp; monitoring</li>
          <li>Staff training &amp; automated fallback failovers</li>
          <li>Full source code handoff &amp; self-hosted infrastructure</li>
        </ul>
        <a href="#book-call" className="tier-btn primary">Schedule Systems Build →</a>
      </div>

      {/* Tier 3 */}
      <div className="tier-card">
        <div className="tier-badge">Partnership</div>
        <h3 className="tier-title">Fractional Head of AI &amp; Retainer</h3>
        <span className="tier-timeline">Monthly Retainer</span>
        <p className="tier-description">
          Ongoing senior AI systems leadership, continuous prompt and eval evolution, multi-model
          routing, and incident response for critical operations.
        </p>
        <ul className="tier-deliverables">
          <li>Direct advisory with Lucas Alves (Founder)</li>
          <li>Ongoing agent optimization &amp; new feature sprints</li>
          <li>Priority SLA &amp; zero-downtime architecture maintenance</li>
          <li>Emerging frontier model evaluation &amp; migration</li>
        </ul>
        <a href="#book-call" className="tier-btn">Inquire for Retainer →</a>
      </div>
    </div>
  );
}
